import { Link } from 'react-router-dom';
import { NavItem } from "./model/nav_item";
import { getLinkClasses, getButtonClasses } from "./navbar_item.styles";

type NavBarItemProps = {
  navItem: NavItem;
};

export default function NavBarItem({ navItem }: NavBarItemProps) {
  return (
    <li className="flex items-right justify-center md:justify-end py-2">
      {navItem.type === "link" ? (
        navItem.to ? (
          <Link to={navItem.to} className={getLinkClasses()} id={navItem.id} onClick={navItem.onClick}>
            {navItem.text}
          </Link>
        ) : (
          <a href={navItem.href} className={getLinkClasses()} id={navItem.id} onClick={navItem.onClick}>
            {navItem.text}
          </a>
        )
      ) : (
        <a
          href={navItem.href}
          className={getButtonClasses(navItem.class ?? "secondary")}
          id={navItem.id}
          onClick={navItem.onClick}
          target={navItem.href.startsWith('http') ? '_blank' : undefined}
          rel={navItem.href.startsWith('http') ? 'noopener noreferrer' : undefined}
        >
          {navItem.text}
        </a>
      )}
    </li>
  );
}
